<!-- Читает Markdown как текст, без выполнения HTML и без зависимости от charset сервера. -->
<template>
  <section class="markdown-attachment-preview" aria-label="Markdown-файл">
    <div class="markdown-attachment-preview__toolbar">
      <a :href="downloadUrl || url" :download="name" target="_blank" rel="noopener noreferrer">Скачать .md</a>
    </div>
    <base-loader v-if="loading" />
    <div v-else-if="error" class="markdown-attachment-preview__error" role="status">
      <p>Не удалось прочитать файл. Можно повторить загрузку или скачать .md.</p>
      <base-button @click="load">Повторить</base-button>
    </div>
    <pre v-else class="markdown-attachment-preview__text" tabindex="0">{{ text }}</pre>
  </section>
</template>
<script>
import { useAttachmentStore } from "@/stores/attachmentStore";
export default {
  name: "AttachmentMarkdownPreview",
  props: { url: { type: String, required: true }, name: { type: String, required: true } },
  data() { return { loading: false, error: false, text: "", downloadUrl: "", request: null }; },
  computed: { store() { return useAttachmentStore(); } },
  watch: { url: { immediate: true, handler() { this.load(); } } },
  beforeUnmount() { this.request?.abort(); this.releaseDownload(); },
  methods: {
    releaseDownload() { if (this.downloadUrl) URL.revokeObjectURL(this.downloadUrl); this.downloadUrl = ""; },
    async load() {
      this.request?.abort();
      this.releaseDownload();
      const request = new AbortController(); this.request = request;
      this.loading = true; this.error = false; this.text = "";
      try {
        const text = await this.store.readMarkdown(this.url, { signal: request.signal });
        if (request.signal.aborted) return;
        this.text = text;
        this.downloadUrl = URL.createObjectURL(new Blob([text], { type: "text/markdown;charset=utf-8" }));
      } catch { if (!request.signal.aborted) this.error = true; }
      finally { if (!request.signal.aborted) this.loading = false; }
    },
  },
};
</script>
<style scoped>
.markdown-attachment-preview { width: 100%; max-width: 1000px; align-self: stretch; min-width: 0; color: #111827; background: #fff; border-radius: 8px; padding: 20px; }
.markdown-attachment-preview__toolbar { margin-bottom: 16px; }
.markdown-attachment-preview__toolbar a { color: var(--color-blue); text-decoration: underline; }
.markdown-attachment-preview__text { margin: 0; max-height: calc(100dvh - 230px); overflow: auto; white-space: pre-wrap; overflow-wrap: anywhere; font: 14px/1.6 monospace; }
.markdown-attachment-preview__text:focus-visible { outline: 2px solid var(--color-blue); outline-offset: 4px; }
.markdown-attachment-preview__error p { margin-bottom: 12px; }
@media (max-width: 600px) { .markdown-attachment-preview { padding: 14px; } }
</style>
